import React from 'react';
import { cn } from '../../utils';
import { useChatStore } from '../../stores/chatStore';
import AgentAvatar from '../Common/AgentAvatar';
import MarkdownRenderer from './MarkdownRenderer';

interface StreamingMessageProps {
  conversationId: string;
  className?: string;
}

export function StreamingMessage({ conversationId, className = '' }: StreamingMessageProps) {
  const streamingMessageId = useChatStore((state) => state.streamingMessageIds?.[conversationId]);
  const tokens = useChatStore((state) =>
    streamingMessageId ? state.streamingTokens?.[streamingMessageId] : undefined,
  );
  const conversations = useChatStore((state) => state.conversations ?? []);
  const agents = useChatStore((state) => state.agents ?? []);

  if (!streamingMessageId || !tokens || tokens.length === 0) {
    return null;
  }

  const content = tokens.join('');
  const conversation = conversations.find((item) => item.id === conversationId) ?? null;
  const agent = agents.find((item) => item.id === conversation?.agentId) ?? agents[0] ?? null;

  return (
    <div className={className}>
      <div className="flex justify-start">
        <div className="flex max-w-[min(100%,48rem)] items-start gap-3">
          <div className="mt-1 shrink-0">
            <AgentAvatar agent={{ name: agent?.name || 'Assistant', avatar: agent?.avatar }} size="sm" />
          </div>
          <div className="min-w-0">
            <div className="rounded-[1.4rem] rounded-bl-lg border border-border bg-card px-4 py-3 text-foreground shadow-sm shadow-black/10">
              <MarkdownRenderer content={content} />
              <div className="mt-2 flex items-center gap-2 text-xs text-muted-foreground">
                <span>Streaming response</span>
                <span className="inline-block h-3 w-1.5 animate-pulse rounded-full bg-blue-400 ally-status-dot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StreamingMessage;
